import path from 'path';

const filenames: Record<string, number> = {
  'getData.test.ts': 9890,
  'onDataChanged.test.ts': 9891,
  'publishData.test.ts': 9892,
};

export function getTestPort(filename: string): number {
  filename = path.basename(filename);
  const port = filenames[filename];
  if (!port) {
    throw new Error(`No test port defined for ${filename} (please add one)`);
  }
  return port;
}
